import React, { useState } from "react";
import styles from "./AddPage.module.scss";
import ContentHeader from "pages/Profile/components/ContentHeader";
import Button, { SIZE } from "components/Button";
import { CircleClose, Loading } from "components/assets/Icons";
import { getShiftRow } from "./utils/getShiftRow";
import Header from "./components/Header";
import Modal from "components/Modal";
import { ModalAddBreak, ModalAddWorkTimeForecasting } from "../Modals";
import { useEffect } from "react";
import { formatListOfBreaks } from "utils/formatListOfBreaks";
import { changeValueOfTime } from "utils/changeValueOfTime";
import { timeDifference } from "utils/timeDifference";
import { toggleDisabledDays } from "utils/toggleDisabledDays";
import { days } from "utils/constants";
import Message from "../Message";
import userProfile from "services/user.profile";

const AddPage = ({
  setCurrentScreen,
  currentScreen,
  breaksList,
  schedulesList,
  setShowMessage,
  setMessage,
}) => {
  const [daysList, setDaysList] = useState([getShiftRow()]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalState, setModalState] = useState("");
  const [duration, setDuration] = useState([]);
  const [time, setTime] = useState([]);
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState([]);
  const [selectedBreak, setSelectedBreak] = useState("");
  const [selectedForecasting, setSelectedForecasting] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState({});
  const [scheduleName, setScheduleName] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [showInfoMessage, setShowInfoMessage] = useState(false);
  const [typeOfMessage, setTypeOfMessage] = useState("info");
  const [formErrors, setFormErrors] = useState({
    scheduleName: false,
    breaks: false,
    timezone: false,
    forecasting: false,
    days: false,
    time: false,
  });

  const options = toggleDisabledDays(selectedDayOfWeek, days);

  const newSchedule = {
    name: scheduleName,
    breaks: selectedBreak,
    timezone: selectedTimezone.value || "",
    forecasting: selectedForecasting,
    shift: { days: selectedDayOfWeek, time: time, duration: duration },
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setScheduleName(value);
    setFormErrors({
      scheduleName: false,
      breaks: false,
      timezone: false,
      forecasting: false,
      days: false,
      time: false,
    });

    setLoading(false);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const scheduleNames = schedulesList.map((schedule) => schedule.name);
    const isNameMatched = scheduleNames.some(
      (name) => name.toLowerCase() === scheduleName.toLowerCase(),
    );

    if (isNameMatched) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        form: `This name is already in use`,
        name: true,
      }));

      return;
    }
    
    const newErrors = {};

    if (newSchedule.name.trim() === "") {
      newErrors.name = true;
    }
    if (newSchedule.breaks.trim() === "") {
      newErrors.breaks = true;
    }
    if (newSchedule.timezone.trim() === "") {
      newErrors.timezone = true;
    }
    if (newSchedule.forecasting.trim() === "") {
      newErrors.forecasting = true;
    }
    if (newSchedule.shift.days.length === 0) {
      newErrors.days = true;
    }
    if (newSchedule.shift.time.length === 0) {
      newErrors.time = true;
    }
    if (newSchedule.shift.days.some((dayArray) => dayArray.length === 0)) {
      newErrors.days = true;
      setTypeOfMessage("error");
      setInfoMessage(`Check the fields, all are required`);
      setShowInfoMessage(true);
      setTimeout(() => setShowInfoMessage(false), 2500);
    }
    if (newSchedule.shift.days.length < daysList.length) {
      newErrors.days = true;
      setTypeOfMessage("error");
      setInfoMessage(`Check the fields, all are required`);
      setShowInfoMessage(true);
      setTimeout(() => setShowInfoMessage(false), 2500);
    }

    const isValidTime = newSchedule.shift.time.some((timeObj) => {
      return Object.values(timeObj).some((value) => value.trim() === "");
    });

    if (isValidTime) {
      newErrors.time = true;
      setTypeOfMessage("error");
      setInfoMessage(`Check the fields, all are required`);
      setShowInfoMessage(true);
      setTimeout(() => setShowInfoMessage(false), 2500);
    }
    if (Object.keys(newErrors).length > 0) {
      setFormErrors(newErrors);
     
      return;
    }

    const createNewSchedule = async (newSchedule) => {
      setLoading(true);
      try {
        const response = await userProfile.addNewSchedule(newSchedule);
        setTimeout(() => setCurrentScreen(""), 500);
        if (response.status === 201) {
          setTypeOfMessage("success");
          setMessage(`Schedule "${newSchedule.name}" created successfully`);
          setTimeout(() => setShowMessage(true), 900);
          setTimeout(() => setShowMessage(false), 2900);
        }
      } catch (error) {
        if (error?.response?.status === 500) {
          setTypeOfMessage("error");
          setInfoMessage("Ooops, something went wrong. Check all fields");
          setShowInfoMessage(true);
          setTimeout(() => setShowInfoMessage(false), 1900);
        }
        console.error("error >>:", error);
      } finally {
        setLoading(false);
      }
    };
    createNewSchedule(newSchedule);
  };

  useEffect(() => {
    setShowInfoMessage(false);
    setFormErrors({
      scheduleName: false,
      breaks: false,
      timezone: false,
      forecasting: false,
      days: false,
      time: false,
    });
    const newDuration = time.map(
      ({ start_hours, start_minutes, end_hours, end_minutes }) =>
        timeDifference(start_hours, start_minutes, end_hours, end_minutes),
    );
    setDuration(newDuration);
  }, [
    setCurrentScreen,
    time,
    selectedBreak,
    selectedTimezone,
    selectedForecasting,
    selectedDayOfWeek,
    scheduleName,
  ]);

  const addDay = () => {
    setDaysList((prevDaysList) => [...prevDaysList, getShiftRow()]);
    setDuration((prevDuration) => [...prevDuration, ""]);
    setTime((prevTime) => [
      ...prevTime,
      {
        start_hours: "",
        start_minutes: "",
        end_hours: "",
        end_minutes: "",
      },
    ]);
  };

  const deleteDay = (id) => {
    setDaysList((prevDaysList) =>
      prevDaysList.filter((_, index) => index !== id),
    );
    setTime((prevTime) => prevTime.filter((_, index) => index !== id));
    setDuration((prevDuration) =>
      prevDuration.filter((_, index) => index !== id),
    );
    setSelectedDayOfWeek((prev) => prev.filter((_, index) => index !== id));
  };

  return (
    <div>
      <ContentHeader
        title="Add Schedule"
        handleClickBack={() => setCurrentScreen("")}
        custom_wrapper={styles.contentheader}
      />
      <form
        className={styles.form}
        method="POST"
        action="submit"
        onSubmit={handleOnSubmit}
        noValidate
      >
        <div className={styles.wrapper}>
          <ul className={styles.scheduleList}>
            <li className={styles.row}>
              <Header
                breaksList={formatListOfBreaks(breaksList)}
                setShowModal={setShowModal}
                setModalState={setModalState}
                currentScreen={currentScreen}
                setSelectedTimezone={setSelectedTimezone}
                selectedTimezone={selectedTimezone}
                setSelectedForecasting={setSelectedForecasting}
                selectedForecasting={selectedForecasting}
                setSelectedBreak={setSelectedBreak}
                selectedBreak={selectedBreak}
                scheduleName={scheduleName}
                setScheduleName={setScheduleName}
                handleChange={handleChange}
                showModal={showModal}
                setLoading={setLoading}
                formErrors={formErrors}
              />
            </li>

            {daysList.map((day, idRow) => (
              <li key={idRow} className={styles.row}>
                {getShiftRow(
                  idRow,
                  changeValueOfTime,
                  duration[idRow],
                  time[idRow],
                  setTime,
                  day,
                  setSelectedDayOfWeek,
                  selectedDayOfWeek[idRow],
                  options,
                  formErrors,
                )}
                <button
                  className={styles.button_circleClose}
                  type="button"
                  onClick={() => deleteDay(idRow)}
                >
                  <CircleClose />
                </button>
              </li>
            ))}
          </ul>

          <div>
            <button
              type="button"
              className={styles.add_button}
              onClick={() => addDay()}
            >
              + Add a Day
            </button>
          </div>

          <Button
            type="submit"
            size={SIZE.MIDDLE}
            className={styles.save_button}
            disabled={loading}
          >
            {loading ? <Loading /> : "Save"}
          </Button>
        </div>
      </form>
      {showInfoMessage && (
        <Message
          text={infoMessage}
          showMessage={showInfoMessage}
          typeOfMessage={typeOfMessage}
          customStyles={{ top: "35px" }}
        />
      )}
      {showModal && (
        <Modal
          setShowModal={setShowModal}
          className={modalState === "addBrake" && styles.modal}
          content={
            modalState === "addBrake" ? (
              <ModalAddBreak
                setShowModal={setShowModal}
                setInfoMessage={setInfoMessage}
                setShowInfoMessage={setShowInfoMessage}
                setTypeOfMessage={setTypeOfMessage}
              />
            ) : modalState === "addWorkTimeForecasting" ? (
              <ModalAddWorkTimeForecasting
                setShowModal={setShowModal}
                setInfoMessage={setInfoMessage}
                setShowInfoMessage={setShowInfoMessage}
                setTypeOfMessage={setTypeOfMessage}
              />
            ) : (
              <></>
            )
          }
        />
      )}
    </div>
  );
};

export default AddPage;
